import md5 from "js-md5";

export let sign = (data)=>{
  let key = "jszkjoa2024@"; //签名Key
  let keys = [];
  for (let k in data){
    if (k == 'sign' || k == 'undefined' || k == '0' || k == 0 || k == 'null' || k ==null){
      continue;
    }
    keys.push(k);
  }
  //排序
  keys.sort();
  let kv = [];
  for (let k of keys){
    if (data[k] == 'undefined' || data[k] == '0' || (data[k] == 0 && data[k] !== '0.00') || data[k] == 'null' || data[k] ==null || (typeof data[k]) == 'object'){
      continue;
    }
    kv.push(k + '=' +  unescape(data[k])) //urlencode编码
  }

  let signStr = kv.join('&');
  signStr = signStr + "&key="+key;
  signStr = md5(signStr)
  return signStr;
}